import queryProducts from './lib/queryProducts.js'
import fetchProductCatalog from './lib/fetchProductCatalog.js'
import storeProductCatalogTaxonomies from './lib/storeProductCatalogTaxonomies.js'
import applogger from '@applogger'
import debuglogger from 'src/debuglogger'
import createProfiler from 'app/profiler'

// Product Loaders
import loadProductImages from './utils/loadProductImages'

function asyncLoader(store, catalogue = '', profiler = createProfiler(false), forceLite = false) {
  // Same condition stripSsrDeferredFields (applyFieldMapper.js) uses to
  // decide whether to strip deferred fields from the JS objects - reused
  // here so the network request actually matches what happens to the data
  // afterward, instead of always fetching full and only trimming client-side.
  const variant = (process.env.SERVER_BUILD === 'ssr' || forceLite) ? 'lite' : 'full'
  profiler.start('wine-catalog:fetchProductCatalog')
  return fetchProductCatalog(store, variant)
    .then(r => {
      profiler.end('wine-catalog:fetchProductCatalog')
      return r
    })
    .catch(() => {
      profiler.end('wine-catalog:fetchProductCatalog', { fellBackToGraphQL: true })
      profiler.start('wine-catalog:queryProducts-fallback')
      // queryProducts hits GraphQL directly, bypassing the REST wrapper
      // that implements variant filtering - this fallback always gets the
      // full catalog regardless of `variant` above. stripSsrDeferredFields
      // (applied to every product below, via detectAndMapProducts) still
      // trims it client-side same as before, so correctness is unaffected -
      // just no backend/network saving on this fallback path.
      return queryProducts(store).then(r => {
        profiler.end('wine-catalog:queryProducts-fallback')
        return r
      })
    })
  // return queryProducts(store)
    .then((response) => {
      if (Object.prototype.hasOwnProperty.call(response, 'data')) {
        const requestResults = response.data
        storeProductCatalogTaxonomies(requestResults, store)
        store.dispatch('products/loadAllMaps', requestResults)
        const products = requestResults.products ?? []
        // Guarded directly (not just relying on debuglogger's internal
        // no-op) - JSON.stringify(products) is real, non-trivial work that
        // Terser can't prove is discarded just by looking at the
        // debuglogger.log(...) call site, so it would otherwise still run
        // on every catalogue load even with DEBUG_LOGGING off.
        if (process.env.DEBUG_LOGGING) {
          debuglogger.log(`[wine-catalog] ${variant} catalogue loaded: ${products.length} products, ${JSON.stringify(products).length} bytes`)
        }
        return products
      }
      else {
        const errorMessage = Object.prototype.hasOwnProperty.call(response, 'errors') && response.errors.length > 0
          ? `Error loading Products:`
          : 'Something went wrong while attempting to load products.'

        applogger.error(errorMessage)

        if (Object.prototype.hasOwnProperty.call(response, 'errors')) {
          response.errors.map(error => applogger.error(error))
        }

        return []
      }
    })
    .then((products) => {
      if (products.length > 0) {
        let alteredProducts = JSON.parse(JSON.stringify(products))

        profiler.start(`wine-catalog:detectAndMapProduct(${alteredProducts.length})`)
        return store.dispatch('products/detectAndMapProducts', { products: alteredProducts, profile: profiler.enabled, forceLite })
          .then((mappedProducts) => {
            profiler.end(`wine-catalog:detectAndMapProduct(${alteredProducts.length})`)
            store.dispatch('products/storeProducts', mappedProducts)
            loadProductImages(mappedProducts, store)
          })
      }
      else {
        return []
      }
    })
    .catch(err => {
      applogger.log(err)
      return []
    })
}

export { asyncLoader }
